export default __webpack_public_path__ + "static/media/1.da2c83eb.jpg";